const getLength = element => {
    if (Array.isArray(element)) return element.length;
    if (typeof element === "string") return element.length;
    if (typeof element === "number") return element;
  
    if (element.hasOwnProperty('length')) return element.length;
  
    throw new Error("Validator error: incorrect checked element format", element);
}
  
const validateLength = (element, validation) => {
    if (!validation) return { error: false };

    if (element == null) {
      if (validation.rules.required) return { 
        type: "required",
        error: validation.messages.required 
      };
      else return { error: false };
    }
  
    let length = getLength(element);
    if (length < 0) throw new Error("Validator error: checked element lenght less then zero")
    
    if (validation.rules.required && length === 0) {
      return { 
        type: "required",
        error: validation.messages.required 
      };
    }
  
    if (validation.rules.min && length < validation.rules.min) {
      return { 
        type: "min",
        error: validation.messages.min,
        length: length,
      };
    }
  
    if (validation.rules.max && length > validation.rules.max) {
      return { 
        type: "max",
        error: validation.messages.max,
        length: length,
      };
    }
  
    return { 
      error: false,
      length: length,
    };
};

export { getLength, validateLength };